import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { useFeatureEnabled } from "@/hooks";
import { TextField } from "@gemini/ui";
import { Controller } from "react-hook-form";
import { phoneNumberInputTestId } from "./constants";
export const PhoneNumberInput = ({ control }) => {
    const { t } = useI18n();
    const isPhoneNumberRequired = useFeatureEnabled("phoneNumberRequired");
    return (_jsx(Controller, { name: "phoneNumber", control: control, defaultValue: "", render: ({ field: { onChange, value, ...field }, fieldState: { error }, }) => (_jsx(TextField, { ...field, type: "tel", isFullWidth: true, testId: phoneNumberInputTestId, label: t("contact.form.phone"), placeholder: t("contact.form.phone_placeholder"), error: error === null || error === void 0 ? void 0 : error.message, isOptional: !isPhoneNumberRequired, hasNecessityIndicator: !isPhoneNumberRequired, value: value, onChange: (event) => {
                const sanitizedValue = event.replace(/(?!^\+)[^\d]/g, "");
                if (sanitizedValue.length > 15) {
                    return;
                }
                onChange(sanitizedValue);
            } })) }));
};
